export class PuzzleApiError extends Error {
  constructor(code, status) {
    super(code);
    this.code = code;
    this.status = status;
  }
}

const request = async (url, options = {}) => {
  let response;

  try {
    response = await fetch(url, { credentials: 'same-origin', ...options });
  } catch (error) {
    throw new PuzzleApiError('network', 0);
  }

  // When the API is unreachable the host answers with the site's HTML, which is not JSON.
  const body = await response.json().catch(() => null);

  if (!response.ok || !body) {
    throw new PuzzleApiError(body && body.error ? body.error : 'server_error', response.status);
  }

  return body;
};

export const getCase = (guid) =>
  request(guid ? `/api/case.php?c=${encodeURIComponent(guid)}` : '/api/case.php');

export const spendHint = (guid) =>
  request('/api/hint.php', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ c: guid })
  });

export const guess = (guid, suspect, clue) =>
  request('/api/guess.php', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ c: guid, suspect, clue })
  });

export const getAnswer = (guid) =>
  request(`/api/answer.php?c=${encodeURIComponent(guid)}`);

export const joinList = (guid, nickname, email) =>
  request('/api/optin.php', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ c: guid, nickname, email })
  });

export const getMe = () => request('/api/me.php');

export const getStandings = (sort) => request(`/api/standings.php?sort=${encodeURIComponent(sort)}`);

export const getMyRecord = (page = 1) => request(`/api/my-record.php?page=${page}`);
